export type Emphasis = 'plain' | 'em' | 'wipe'

/** `**phrase**` is the accent. `[[phrase]]` is the reset warning. Not HTML. */
export function emphasisParts(text: string): { emphasis: Emphasis; text: string }[] {
  const parts: { emphasis: Emphasis; text: string }[] = []
  const pattern = /\*\*([^*]+)\*\*|\[\[([^\]]+)\]\]/g
  let last = 0
  let match: RegExpExecArray | null
  while ((match = pattern.exec(text))) {
    if (match.index > last) {
      parts.push({ emphasis: 'plain', text: text.slice(last, match.index) })
    }
    parts.push({
      emphasis: match[1] !== undefined ? 'em' : 'wipe',
      text: (match[1] ?? match[2] ?? ''),
    })
    last = match.index + match[0].length
  }
  if (last < text.length) parts.push({ emphasis: 'plain', text: text.slice(last) })
  if (parts.length === 0) parts.push({ emphasis: 'plain', text })
  return parts
}
